<template>
  <b-container>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Observador</span>
      </h5>
    </div>
    <b-row>
      <b-col>
        <div class="card border-0" id="max-w-70" v-if="observerUser && observerUser.observations">
          <div class="card-body">
            <div id="w-70"></div>
            <b-row class="mb-3">
              <b-col md="4" xl="3">
                <div class="text-center">
                  <img v-show="observerUser.observations.pathAvatar !== '' && observerUser.observations.pathAvatar !== null"
                    :src="`${observerUser.observations.pathAvatar}?tr=w-140`"
                    @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                    class="rounded-circle img-thumbnail" alt="..." id="img-h-150px">
                </div>
              </b-col>
              <b-col md="7" xl="9">
                <h2>
                  {{ getFullName(observerUser.observations)  }}
                  <router-link v-if="!isEdit && hasPermission([consts.permissions.CREATE_OBSERVATIONS]) && !(user.id == observerUser.observations.id) && (this.$route.params.userObserved != observerUser.observations.id)" :to="{ name: 'observationsCreate', params: { userObserved: observerUser.observations.id } }" class="position-absolute z-index-1 mr-2">
                    <a-button type="primary" shape="circle" icon="plus" class="ml-3" />
                  </router-link>
                </h2>
                <p>
                  <b>Identificación</b>: {{ observerUser.observations.cc }} <br>
                  <span v-if="observerUser.observations.currentGrade"><b>Grado</b>: {{ observerUser.observations.currentGrade.name }} <br></span>
                  <span v-if="observerUser.observations.userProfile">
                   <span v-if="observerUser.observations.userProfile.mother"> <b>Madre</b>: {{ observerUser.observations.userProfile.mother.names + ' ' + observerUser.observations.userProfile.mother.lastNames }} <br> </span>
                   <span v-if="observerUser.observations.userProfile.father"> <b>Padre</b>: {{ observerUser.observations.userProfile.father.names + ' ' + observerUser.observations.userProfile.father.lastNames }} <br> </span>
                  </span>
                  <span v-if="observerUser.observedRole === consts.roles.ESTUDIANTE">
                    <b class="text-success">Cantidad de observaciones positivas</b>: {{ observerUser.positive }} <br>
                      <b class="color-obs-attention">Cantidad de observaciones de llamado de atención</b>: {{ observerUser.attention }} <br>
                      <span v-if="observerUser.attention > 0" class="mb-1">
                        <ul class="mb-0">
                          <li><b class="colorI">Cantidad de situaciones tipo I </b>: {{ observerUser.typeI }} </li>
                          <li><b class="colorII">Cantidad de situaciones tipo II </b>: {{ observerUser.typeII }} </li>
                          <li><b class="colorIII">Cantidad de situaciones tipo III </b>: {{ observerUser.typeIII }} </li>
                        </ul>
                    </span>
                    <b class="color-obs-followUp">Cantidad de observaciones de seguimiento</b>: {{ observerUser.followUp }} <br>
                  </span>
                  <span v-else>
                    <b class="text-success">Cantidad de observaciones positivas</b>: {{ observerUser.positive }} <br>
                    <b class="color-obs-attention">Cantidad de observaciones de llamado de atención</b>: {{ observerUser.attention }} <br>
                    <b class="color-obs-followUp">Cantidad de observaciones de seguimiento</b>: {{ observerUser.followUp }} <br>
                  </span>
                </p>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col v-if="observerUser.observations">
                <span v-if="isHistory">
                  <div class="row mt-2" v-if="this.filter">
                    <b-col sm="12" md="6" lg="4">
                      <b-form-group id="input-group-1" label="Tipo de observación:">
                      <b-form-select v-model="selectObservationType" :options="observationTypes"></b-form-select>
                    </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <b-form-group id="input-group-2" label="Docente:">
                        <b-form-select v-model="selectTeacher" :options="teachers"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <b-form-group id="input-group-3" label="Ordenar por fecha:">
                        <b-form-select v-model="selectOrder" :options="orderOption"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </div>
                  <div class="card p-3" v-for="(observation, i) in observerUser.observations.observed" :key="i">
                    <div class="card-header card-header-flex card-header-borderless mt-2 mx-2 p-0">
                        <div v-if="observerUser.observedRole === consts.roles.ESTUDIANTE" class="d-flex flex-column justify-content-center mr-auto mb-1">
                          <h3 :class="{
                            ['text-success']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_POSITIVE,
                            ['color-obs-attention']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION,
                            ['color-obs-followUp']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_FOLLOW_UP,
                            }">Observación <span class="text-lowercase">{{ observation.observationType}}</span>
                          </h3>
                          <h5 v-if="observation.situationType !== consts.TYPE_OBSERVATION.NA" :class="{
                            ['colorI']: observation.situationType === consts.TYPE_OBSERVATION.SITUATION_I,
                            ['colorII']: observation.situationType === consts.TYPE_OBSERVATION.SITUATION_II,
                            ['colorIII']: observation.situationType === consts.TYPE_OBSERVATION.SITUATION_III}">
                            Tipo de situación: {{ observation.situationType }}
                            <b-row v-if="observation.fault" class="mt-2 m-0">Falta de {{ observation.fault.category }}: {{  observation.fault.name}}</b-row>
                          </h5>
                        </div>
                        <div v-else  class="d-flex flex-column justify-content-center mr-auto mb-1">
                          <h3 :class="{
                            ['text-success']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_POSITIVE,
                            ['color-obs-attention']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION,
                            ['color-obs-followUp']: observation.observationType === consts.TYPE_OBSERVATION.TYPE_FOLLOW_UP,
                            }">Observación <span class="text-lowercase">{{ observation.observationType}}</span>
                          </h3>
                        </div>
                        <div class="d-flex flex-column justify-content-center mr-2">
                          {{moment(observation.createdAt).format('LLLL')}}
                        </div>
                      <div class="d-flex flex-column justify-content-center" v-if="hasPermission([consts.permissions.UPDATE_OBSERVATIONS, consts.permissions.DELETE_OBSERVATIONS]) && !(user.id == observerUser.observations.id) && user.roles.some((e) => hierarchy(observation.creator.roles[0].id , observerUser.observedRole, e))">
                        <a-dropdown placement="bottomRight" :trigger="['click']">
                          <button type="button" class="btn btn-light">
                            <i class="fe fe-more-vertical" />
                          </button>
                          <a-menu slot="overlay">
                            <a-menu-item>
                              <a href="javascript:;" @click="editObservation(observation.id)" v-if="hasPermission([consts.permissions.UPDATE_OBSERVATIONS])">Editar</a>
                            </a-menu-item>
                            <a-menu-item>
                              <a href="javascript:;"  @click="deleteObservacion(observation)" v-if="hasPermission([consts.permissions.DELETE_OBSERVATIONS])">Eliminar</a>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </div>
                    </div>
                    <div class="card-body px-2">
                      <p><b>Creada por: </b>{{ getFullName(observation.creator) }}</p>
                      <span v-html="fixObservation(observation.description)"></span>
                      <p><b>Compromiso: </b> {{ observation.commitment }}</p>
                    </div>
                  </div>
                  <empty-table v-if="observerUser.observations.observed.length === 0" />
                  <router-link v-if="hasPermission([consts.permissions.CREATE_OBSERVATIONS]) && !(user.id == this.$route.params.idUser) && (observerUser.observations.observed.length > 1) && (!myReport)" :to="'/observations/management'">
                      <b-button variant="primary">Volver al gestor de observaciónes</b-button>
                  </router-link>
                </span>
                <b-form @submit.stop.prevent v-else>
                  <b-row class="mt-4">
                    <b-col>
                      <div class="row mx-auto" v-if="observerUser.observedRole === consts.roles.ESTUDIANTE">
                          <b-form-group class="col-xs-12 col-sm-5 col-md-4 col-lg-3" id="input-group-1" label-for="input-1">
                            <label for="input-1"><b class="text-danger">* </b>Tipo de observación:</label>
                            <b-form-select v-model="observation.observationType" :options="observationTypes" required></b-form-select>
                            <b-form-invalid-feedback :state="errors.observationType === ''">{{ errors.observationType }}</b-form-invalid-feedback>
                          </b-form-group>
                            <b-form-group class="col-xs-12 col-sm-5 col-md-4 col-lg-3" id="input-group-2" label-for="input-2" v-if="(observerUser.observedRole === consts.roles.ESTUDIANTE) && observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && hasRole([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR])">
                              <label for="input-2"><b class="text-danger">* </b>Tipo de situación:</label>
                              <b-form-select v-model="observation.situationType" :options="situationType" required></b-form-select>
                              <b-form-invalid-feedback :state="errors.situationType === ''">{{ errors.situationType }}</b-form-invalid-feedback>
                            </b-form-group>
                          <b-form-group class="col-xs-12 col-sm-5 col-md-4 col-lg-3" id="input-group-3" label-for="input-2" v-if="(observerUser.observedRole === consts.roles.ESTUDIANTE) && observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && observation.situationType === consts.TYPE_OBSERVATION.SITUATION_I && hasRole([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR])">
                            <label for="input-3"><b class="text-danger">* </b>Tipo de falta:</label>
                            <b-form-select v-model="observation.fault" :options="faultType" required></b-form-select>
                            <b-form-invalid-feedback :state="errors.fault === ''">{{ errors.fault }}</b-form-invalid-feedback>
                          </b-form-group>
                          <b-form-group class="col-xs-12 col-sm-5 col-md-4 col-lg-3" id="input-group-2" label-for="input-2" v-if="(observerUser.observedRole === consts.roles.ESTUDIANTE) && observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && hasRole([consts.rolesText.DOCENTE, consts.rolesText.PSICOLOGO])">
                            <label for="input-2"><b class="text-danger">* </b>Tipo de falta:</label>
                            <b-form-select v-model="observation.fault" :options="faultType" required></b-form-select>
                            <b-form-invalid-feedback :state="errors.fault === ''">{{ errors.fault }}</b-form-invalid-feedback>
                          </b-form-group>
                      </div>
                      <div class="row mx-auto" v-else>
                          <b-form-group class="col-xs-12 col-sm-5 col-md-4 col-lg-3" id="input-group-1" label-for="input-1">
                            <label for="input-1"><b class="text-danger">* </b>Tipo de observación:</label>
                            <b-form-select v-model="observation.observationType" :options="observationTypes" required></b-form-select>
                            <b-form-invalid-feedback :state="errors.observationType === ''">{{ errors.observationType }}</b-form-invalid-feedback>
                          </b-form-group>
                      </div>
                      <b-col>
                        <b-form-group id="input-group-3" required>
                          <label for="input-3"><b class="text-danger">* </b>Observación:</label>
                          <div class="mb-3">
                            <VueEditor v-model="observation.description" :editor-toolbar="customToolbar2" placeholder="Ingrese la descripción de la situación. Fecha, lugar, personas implicadas, acciones." />
                          </div>
                          <b-form-invalid-feedback :state="errors.description === ''">{{ errors.description }}</b-form-invalid-feedback>
                          <small :class="{'text-muted': characterEnabled > 0, 'text-danger': characterEnabled <= 0 }">{{ characterEnabled }} caracteres de texto plano restantes</small>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group id="input-group-4">
                          <label for="input-4"><b class="text-danger">* </b>Compromiso:</label>
                          <b-form-textarea
                            id="textarea"
                            v-model="observation.commitment"
                            placeholder="Ingrese el compromiso"
                            rows="3"
                            max-rows="6"
                            required
                          ></b-form-textarea>
                          <b-form-invalid-feedback :state="errors.commitment === ''">{{ errors.commitment }}</b-form-invalid-feedback>
                          <small :class="{'text-muted': characterEnabledCommitment > 0, 'text-danger': characterEnabledCommitment <= 0}">{{ characterEnabledCommitment }} caracteres de texto plano restantes</small>
                        </b-form-group>
                      </b-col>
                    </b-col>
                  </b-row>
                  <b-col offset-xl="3" class="d-flex justify-content-start ml-3" v-if="hasPermission([consts.permissions.CREATE_OBSERVATIONS])">
                    <button class="btn btn-primary mr-2" :disabled="inProgress" variant="primary" v-if="!isEdit" @click="saveObservation(observerUser.observations.id)">Crear Observación</button>
                    <button class="btn btn-primary mr-2" :disabled="inProgress" variant="primary" v-if="isEdit" @click="saveObservation(observerUser.observations.observed[0].id)">Guardar cambios</button>
                    <router-link :to="'/observations/management'">
                      <b-button variant="secondary" size="sm" class="mt-1 ml-2" > {{isEdit ? 'Cancelar e ir gestor de observaciónes': 'Volver al gestor de observaciónes'}}</b-button>
                    </router-link>
                  </b-col>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apiClient2 from '@/services/axios/v2'
import moment from 'moment'
import { VueEditor } from 'vue2-editor'
import { consts, hasRole, hasPermission, hierarchy, getRoleNameById, showErrorMessage } from '../../../services/utilities'
import { mapState } from 'vuex'
import { ToastFire, SwalFire } from '@/services/utilities/swal'
import emptyTable from '@/components/custom/cardEmptyList'

moment.locale('es')

export default {
  name: 'observer',
  components: {
    VueEditor,
    emptyTable,
  },
  props: {
    observerUser: {
      type: Object,
      default: null,
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    myReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      consts,
      observation: {
        id: '',
        description: '',
        observationType: null,
        situationType: null,
        fault: null,
        commitment: '',
        idObserved: '',
      },
      errors: {
        description: '',
        observationType: '',
        situationType: '',
        fault: '',
        commitment: '',
      },
      observationTypes: [
        { value: null, text: 'Seleccione un tipo' },
        { value: consts.TYPE_OBSERVATION.TYPE_POSITIVE, text: 'Positiva' },
        { value: consts.TYPE_OBSERVATION.TYPE_ATTENTION, text: 'Llamado de atención' },
        { value: consts.TYPE_OBSERVATION.TYPE_FOLLOW_UP, text: 'Seguimiento' },
      ],
      situationType: [
        { value: null, text: 'Seleccione tipo de situación' },
        { value: consts.TYPE_OBSERVATION.SITUATION_I, text: 'I' },
        { value: consts.TYPE_OBSERVATION.SITUATION_II, text: 'II' },
        { value: consts.TYPE_OBSERVATION.SITUATION_III, text: 'III' },
      ],
      faultType: [],
      customToolbar2: [[{
        header: [false, 1, 2, 3, 4, 5, 6],
      }], ['bold', 'italic', 'underline', 'strike'],
      [{
        align: '',
      }, {
        align: 'center',
      }, {
        align: 'right',
      }, {
        align: 'justify',
      }], ['blockquote'], [{
        list: 'ordered',
      }, {
        list: 'bullet',
      }, {
        list: 'check',
      }], [{
        indent: '-1',
      }, {
        indent: '+1',
      }], // outdent/indent
      [{
        color: [],
      }, {
        background: [],
      }], ['clean'], // remove formatting button
      ['link'],
      ],
      isActive: true,
      inProgress: false,
      selectOrder: 2,
      orderOption: [
        { value: 1, text: 'Ascendente ' },
        { value: 2, text: 'Descendente ' },
      ],
      teachers: [
        { value: null, text: 'Seleccione el docente' },
      ],
      selectObservationType: null,
      selectTeacher: null,
      filter: false,
    }
  },
  computed: {
    ...mapState(['user']),
    characterEnabled() {
      return 10000 - this.observation.description.length
    },
    characterEnabledCommitment() {
      return 10000 - this.observation.commitment.length
    },
  },
  methods: {
    fixObservation(item) {
      const isP = item.slice(0, 3)
      const start = '<p><b>Descripción: </b>'
      if (isP === '<p>') {
        let text = item.slice(3, -1)
        text = `${start} ${text}`
        return text
      } else { return `${start} ${item}` }
    },
    getFullName(user) {
      if (user) {
        let fullName = user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1)
        if (user.secondName !== null && user.secondName.length > 1) {
          fullName += ' ' + user.secondName.charAt(0).toUpperCase() + user.secondName.slice(1)
        }
        fullName += ' ' + user.firstLastName.charAt(0).toUpperCase() + user.firstLastName.slice(1)
        if (user.secondLastName !== null && user.secondLastName.length > 1) {
          fullName += ' ' + user.secondLastName.charAt(0).toUpperCase() + user.secondLastName.slice(1)
        }
        return fullName
      }
    },
    editObservation(id) {
      this.$router.push({ name: 'observationsEdit', params: { idObservation: id } })
    },
    saveObservation(id) {
      if (this.observation.description.length > 10000 || this.observation.commitment.length > 10000) {
        ToastFire('warning', this.observation.description.length > 10000 ? 'La descripción supera los 10000 caracteres de texto plano permitidos' : 'El compromiso supera los 10000 caracteres de texto plano permitidos')
      } else if (this.isEdit) {
        this.inProgress = true
        let isValid = true
        if (!this.observation.observationType) {
          this.errors.observationType = 'Tipo de observación es requerido.'
          isValid = false
        } else this.errors.observationType = ''
        if (!this.observation.situationType && (this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) && this.observerUser.observedRole === consts.roles.ESTUDIANTE) {
          this.errors.situationType = 'Tipo de situación es requerido.'
          isValid = false
        } else this.errors.situationType = ''
        if (!this.observation.fault && (this.observation.situationType === consts.TYPE_OBSERVATION.SITUATION_I) && this.observerUser.observedRole === consts.roles.ESTUDIANTE) {
          this.errors.fault = 'Tipo de falta es requerido.'
          isValid = false
        } else this.errors.fault = ''
        if (!this.observation.description.replace(/<\/?p\s*\/?>/g, '').trim()) {
          this.errors.description = 'Observación es requerida.'
          isValid = false
        } else this.errors.description = ''
        if (!this.observation.commitment.trim() && this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
          this.errors.commitment = 'Compromiso es requerido.'
          isValid = false
        } else this.errors.commitment = ''
        if (isValid) {
          apiClient2.patch(`/observations/${id}`, this.observation).then(response => {
            ToastFire('success', response.data.message)
            this.$router.push({ name: 'observationsManagement' })
          }).catch((error) => {
            this.inProgress = false
            ToastFire('warning', showErrorMessage(error),
            )
          })
        } else {
          this.inProgress = false
        }
      } else {
        this.inProgress = true
        let isValid = true
        if (!this.observation.observationType) {
          this.errors.observationType = 'Tipo de observación es requerido.'
          isValid = false
        } else this.errors.observationType = ''

        if (this.user.role === consts.rolesText.DOCENTE || this.user.role === consts.rolesText.PSICOLOGO) {
          if (!this.observation.fault && (this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) && this.observerUser.observedRole === consts.roles.ESTUDIANTE) {
            this.errors.fault = 'Tipo de falta es requerido.'
            isValid = false
          } else this.errors.fault = ''
        } else if (([consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.COORDINADOR]).includes(this.user.role)) {
          if (!this.observation.situationType && this.observerUser.observedRole === consts.roles.ESTUDIANTE && this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
            this.errors.situationType = 'Tipo de situación es requerido.'
            isValid = false
          } else this.errors.situationType = ''
          if (!this.observation.fault && (this.observation.situationType === consts.TYPE_OBSERVATION.SITUATION_I) && this.observerUser.observedRole === consts.roles.ESTUDIANTE) {
            this.errors.fault = 'Tipo de falta es requerido.'
            isValid = false
          } else this.errors.fault = ''
        }
        if (!this.observation.description.replace(/<\/?p\s*\/?>/g, '').trim()) {
          this.errors.description = 'Observación es requerida.'
          isValid = false
        } else this.errors.description = ''
        if (!this.observation.commitment.trim() && this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
          this.errors.commitment = 'Compromiso es requerido.'
          isValid = false
        } else this.errors.commitment = ''
        if (this.user.role === consts.rolesText.DOCENTE && ([consts.TYPE_OBSERVATION.SITUATION_II, consts.TYPE_OBSERVATION.SITUATION_III]).includes(this.observation.description)) {
          this.errors.situationType = 'Solo es posible tipo I, según su rol.'
          isValid = false
        }
        if (isValid) {
          if (this.observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION && (this.user.role === consts.rolesText.DOCENTE || this.user.role === consts.rolesText.PSICOLOGO)) {
            this.observation.situationType = consts.TYPE_OBSERVATION.SITUATION_I
          }
          this.observation.description = this.observation.description.replaceAll('<p><br></p>', '<br>').replaceAll('</p><p>', '<br>')
          apiClient2.post(`/observations/${id}`, this.observation).then(response => {
            ToastFire('success', 'Observación guardada satisfactoriamente')
            this.$router.push({ name: 'observationsManagement' })
          }).catch((error) => {
            this.inProgress = false
            ToastFire('warning', showErrorMessage(error))
          })
        } else {
          this.inProgress = false
        }
      }
    },
    async deleteObservacion(observation) {
      const name = observation.name ? this.getFullName(observation) + ' ' + observation.lastName : this.getFullName(this.observerUser.observations)
      const responseSwal = await SwalFire('Mensaje de confirmación', ('¿Desea remover la observación ' + observation.observationType + ' de ' + name))
      if (responseSwal) {
        apiClient2.delete(`/observations/${observation.id}`).then(response => {
          this.observerUser.observations.observed = this.observerUser.observations.observed.filter((item) => { return item.id !== observation.id })
          ToastFire('success', 'observación eliminada correctamente')
          this.$bvModal.hide('seeObservation')
          switch (`${observation.observationType}`) {
            case consts.TYPE_OBSERVATION.TYPE_POSITIVE:
              this.observerUser.positive = this.observerUser.positive - 1
              break
            case consts.TYPE_OBSERVATION.TYPE_ATTENTION:
              this.observerUser.attention = parseInt(this.observerUser.attention, 10) - 1
              break
            case consts.TYPE_OBSERVATION.TYPE_FOLLOW_UP:
              this.observerUser.followUp = this.observerUser.followUp - 1
              break
          }
          if (observation.observationType === consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
            switch (`${observation.situationType}`) {
              case consts.TYPE_OBSERVATION.SITUATION_I:
                this.observerUser.typeI = parseInt(this.observerUser.typeI, 10) - 1
                break
              case consts.TYPE_OBSERVATION.SITUATION_II:
                this.observerUser.typeII = parseInt(this.observerUser.typeII, 10) - 1
                break
              case consts.TYPE_OBSERVATION.SITUATION_III:
                this.observerUser.typeIII = parseInt(this.observerUser.typeIII, 10) - 1
                break
            }
          }
          this.$emit('deleteObservationModal', observation.id)
        }).catch(error => {
          ToastFire('warning', showErrorMessage(error))
        })
      }
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    loadDataEdit() {
      if (this.isEdit) {
        this.observerUser.observations.observed.forEach(observations => {
          this.observation.description = observations.description ? `${observations.description}` : ''
          this.observation.observationType = observations.observationType ? `${observations.observationType}` : ''
          this.observation.situationType = observations.situationType ? `${observations.situationType}` : ''
          this.observationTypes.value = observations.situationType ? `${observations.situationType}` : ''
          this.observation.commitment = observations.commitment ? `${observations.commitment}` : ''
          this.observation.idObserved = observations.idObserved ? `${observations.idObserved}` : ''
          this.observation.fault = observations.idFault ? observations.idFault : null
        })
      } else if (this.isHistory) {
        this.loadTeacher()
      }
    },
    hierarchy(roleCreator, roleObserved, userRole) {
      return hierarchy(roleCreator, roleObserved, getRoleNameById(userRole))
    },
    hasRole(roles) {
      return hasRole(roles, this.user.role)
    },
    filterObservatio () {
      const data = {
        ...(this.selectOrder && { order: this.selectOrder }),
        ...(this.selectTeacher && { creator: this.selectTeacher }),
        ...(this.selectObservationType && { observationType: this.selectObservationType }),
      }
      this.$emit('filterHistory', data)
    },
    loadTeacher() {
      if (!this.selectTeacher) {
        this.teachers = [
          { value: null, text: 'Seleccione el docente' },
        ]
        const idCreator = []
        if (this.observerUser && this.observerUser.observations && this.observerUser.observations.observed) {
          if (this.observerUser.observations.observed.length > 0) {
            for (const item of this.observerUser.observations.observed) {
              if (!idCreator.includes(item.idCreator)) {
                const data = {
                  value: item.idCreator,
                  text: this.getFullName(item.creator),
                }
                this.teachers.push(data)
                idCreator.push(item.idCreator)
              }
            }
          }
        }
      }
    },
  },
  watch: {
    'observerUser.observations': function () {
      this.loadDataEdit()
      if (!this.filter) {
        this.filter = this.observerUser.observations.observed.length > 1
      }
    },
    'observation.observationType': function () {
      if (this.user.role === consts.rolesText.DOCENTE) {
        this.situationType = [
          { value: null, text: 'Seleccione un tipo' },
          { value: consts.TYPE_OBSERVATION.SITUATION_I, text: 'I' },
        ]
      }
      if (this.observation.observationType !== consts.TYPE_OBSERVATION.TYPE_ATTENTION) {
        this.observation.situationType = null
        this.observation.fault = null
      }
    },
    'observation.situationType': function () {
      if (this.observation.situationType !== consts.TYPE_OBSERVATION.SITUATION_I) {
        this.observation.fault = null
      }
    },
    // Filter
    selectOrder: function () {
      this.filterObservatio()
    },
    selectTeacher: function () {
      this.filterObservatio()
    },
    selectObservationType: function () {
      this.teachers = null
      if (this.selectTeacher) {
        this.selectTeacher = null
      } else this.filterObservatio()
    },
  },
  created () {
    apiClient2.get('/faults').then(response => {
      this.faultType = response.data.data.map(fault => ({
        value: fault.id,
        text: fault.name,
      }))
      this.faultType.unshift(({
        value: null,
        text: 'Seleccione la falta',
      }))
    })
    this.loadTeacher()
  },
}
</script>

<style>
.color-obs-attention{
  color: #821818;
}
.colorI{
  color: #c76c7f;
}
.colorII{
  color: #c76c7f;
}
.colorIII{
  color: #c76c7f;
}
.color-obs-followUp{
  color: #b5acae;
}
 #max-w-70{
  max-width: 70rem;
}
#w-70{
    width: 70rem;
}
#img-h-150px{
  height: 150px;
}
</style>
